module.exports = __webpack_public_path__ + "static/img/logo09.d046608.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo09.png
// module id = ujs7
// module chunks = 1